import { Plus, Sparkles, Trash2 } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { errText } from "@/components/prospect/common";
import { ScriptEditor } from "@/components/prospect/ScriptEditor";

const BLANK = { name: "Nouveau script", description: "", steps: [{ title: "Accroche", say: "Bonjour, ici Airthermo, je souhaiterais parler au responsable des bâtiments de {ville}…", questions: [] }] };

export function ScriptsTab() {
  const [scripts, setScripts] = useState([]);
  const [edit, setEdit] = useState(null);
  const [brief, setBrief] = useState("");
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/call-scripts").then(({ data }) => setScripts(data)), []);
  useEffect(() => { load(); }, [load]);
  const generate = async () => {
    setBusy(true);
    try { setEdit((await api.post("/call-scripts/generate", { brief })).data); toast.success("Script rédigé par l'IA : relisez-le puis enregistrez."); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  const remove = async (s) => { if (!window.confirm(`Supprimer le script « ${s.name} » ?`)) return; await api.delete(`/call-scripts/${s.id}`); load(); };
  if (edit) return <ScriptEditor script={edit} onClose={() => { setEdit(null); load(); }} />;
  return (
    <div className="ps-scripts" data-testid="scripts-tab">
      <section className="ps-card ps-scripts-ai">
        <h3><span><Sparkles size={14} /> Faire rédiger un script par l'IA</span></h3>
        <textarea rows={3} value={brief} onChange={(e) => setBrief(e.target.value)} placeholder="Ex. : appel à froid vers les mairies de moins de 5 000 habitants pour une PAC collective financée par les CEE, objectif : rendez-vous avec le maire ou le DGS." data-testid="scripts-ai-brief" />
        <button type="button" className="primary-button" disabled={busy || brief.trim().length < 10} onClick={generate} data-testid="scripts-ai-generate"><Sparkles size={15} /> {busy ? "Rédaction en cours…" : "Rédiger le script"}</button>
      </section>
      <div className="ps-scripts-head"><h3>Scripts d'appel ({scripts.length})</h3><button type="button" className="secondary-button" onClick={() => setEdit(BLANK)} data-testid="scripts-new"><Plus size={14} /> Script vierge</button></div>
      {!scripts.length && <p className="ps-calls-empty">Aucun script pour l'instant. Rédigez-en un avec l'IA ou partez d'un script vierge.</p>}
      <ul className="ps-scripts-list">
        {scripts.map((s) => (
          <li key={s.id} data-testid={`script-item-${s.id}`}>
            <button type="button" className="ps-scripts-open" onClick={() => setEdit(s)} data-testid={`script-edit-${s.id}`}><strong>{s.name}</strong><span>{s.steps.length} étapes · {s.steps.reduce((n, st) => n + st.questions.length, 0)} questions</span></button>
            <button type="button" className="icon-button" onClick={() => remove(s)} data-testid={`script-delete-${s.id}`}><Trash2 size={15} /></button>
          </li>
        ))}
      </ul>
    </div>
  );
}
